module.exports = __webpack_public_path__ + "img/fishing.66325662.jpg";